import { supabase } from "@/lib/supabase";

export function webAuthnAvailable() {
  return typeof window !== "undefined"
    && !!window.isSecureContext
    && typeof window.PublicKeyCredential === "function";
}

/** User-facing copy. Returns null when the user cancelled the platform prompt. */
export function passkeyUserMessage(err, action = "sign-in") {
  if (!err) return action === "register" ? "Could not add a passkey." : "Passkey sign-in failed.";
  const code = err.code || err.error_code || "";
  const name = err.name || "";
  const raw = String(err.message || "");
  const low = raw.toLowerCase();

  if (
    name === "NotAllowedError"
    || name === "AbortError"
    || low.includes("the operation either timed out or was not allowed")
    || low.includes("user cancelled")
    || low.includes("canceled")
    || low.includes("aborted")
  ) {
    return null;
  }
  if (name === "AuthSessionMissingError" || low.includes("auth session missing")) {
    return "Sign out and back in to manage passkeys.";
  }
  if (code === "passkey_disabled" || low.includes("passkey_disabled") || low.includes("passkeys are disabled")) {
    return "Passkeys are not enabled on this project yet. Email and Google still work.";
  }
  if (code === "webauthn_credential_not_found") {
    return "No passkey found. Sign in with email or Google, then add one in Settings.";
  }
  if (code === "webauthn_credential_exists") {
    return "This passkey is already on the account.";
  }
  if (code === "too_many_passkeys") {
    return "This account already has the maximum number of passkeys.";
  }
  if (code === "webauthn_challenge_expired" || code === "webauthn_challenge_not_found") {
    return "Passkey timed out. Try again.";
  }
  if (code === "webauthn_verification_failed") {
    return "That passkey could not be verified. Try another method.";
  }
  if (low.includes("does not support webauthn")) {
    return "This browser does not support passkeys.";
  }
  if (low.includes("experimental") && low.includes("passkey")) {
    return "Passkey client is not opted in. Email and Google still work.";
  }
  return raw || (action === "register" ? "Could not add a passkey." : "Passkey sign-in failed.");
}

export async function listPasskeys() {
  const { data, error } = await supabase.auth.passkey.list();
  if (error) throw error;
  return Array.isArray(data) ? data : [];
}

export async function registerPasskey() {
  const { data, error } = await supabase.auth.registerPasskey();
  if (error) throw error;
  return data;
}

export async function deletePasskey(passkeyId) {
  const { error } = await supabase.auth.passkey.delete({ passkeyId });
  if (error) throw error;
}

export function formatPasskeyWhen(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "";
  }
}
